export enum CustomConditionalType {
	OnlyShowIfDataContainsId,
	AlwaysHidden
}
